export function renderText(
    text: string,
    context: any = {}
) {

  return text.replace(
      /\{(.*?)\}/g,
      (_, expr) => {

        try {

          return Function(
              "__scope",
              `
               with (__scope) {
                 return (${expr})
               }
               `
          )(
              context
          );

        } catch {

          return "";
        }
      }
  );
}
export default renderText;
